export interface Project {
  id: string;
  user_id: number;
  name: string;
  description?: string;
  status: ProjectStatus;
  start_date?: string;
  target_date?: string;
  completed_date?: string;
  progress_percentage: number; // 0-100 percentage
  notes?: string;
  created_at: string;
  updated_at: string;
}

export enum ProjectStatus {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  ON_HOLD = 'on_hold',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

export interface ProjectFormData {
  name: string;
  description?: string;
  status: ProjectStatus;
  start_date?: string;
  target_date?: string;
  progress_percentage?: number;
  notes?: string;
}

export interface ProjectFilters {
  status?: ProjectStatus;
  searchQuery?: string;
  sortBy?: 'name' | 'created_at' | 'target_date' | 'progress_percentage';
  sortOrder?: 'asc' | 'desc';
}

